export const services = [
  {
    id: 1,
    title: 'Instalación de Aires Acondicionados',
    description: 'Instalación profesional de equipos split, ventana y central. Nuestros técnicos certificados garantizan una instalación perfecta desde el primer día.',
    icon: 'ri-install-line',
  },
  {
    id: 2,
    title: 'Mantenimiento Preventivo',
    description: 'Servicios de limpieza, revisión y ajuste periódico para mantener tu equipo funcionando al máximo rendimiento y extender su vida útil.',
    icon: 'ri-tools-line',
  },
  {
    id: 3,
    title: 'Reparación y Diagnóstico',
    description: 'Diagnóstico rápido y reparación de fallas eléctricas, mecánicas o de refrigerante. Utilizamos repuestos originales de calidad.',
    icon: 'ri-settings-3-line',
  },
  {
    id: 4,
    title: 'Instalación Comercial',
    description: 'Soluciones de climatización para oficinas, negocios y espacios comerciales. Diseñamos sistemas adaptados a tus necesidades.',
    icon: 'ri-building-2-line',
  },
  {
    id: 5,
    title: 'Recarga de Gas Refrigerante',
    description: 'Recarga profesional de gas R-22, R-410A y otros refrigerantes ecológicos. Detectamos fugas y sellamos el sistema correctamente.',
    icon: 'ri-drop-line',
  },
  {
    id: 6,
    title: 'Ductos y Ventilación',
    description: 'Instalación y mantenimiento de sistemas de ductos para climatización central. Aseguramos flujo de aire eficiente y silencioso.',
    icon: 'ri-windy-line',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Carlos Mendoza',
    role: 'Propietario de Casa',
    content: 'Excelente servicio. Instalaron el aire acondicionado en mi casa en tiempo récord. Los técnicos fueron muy profesionales y dejaron todo limpio.',
    rating: 5,
  },
  {
    id: 2,
    name: 'María Fernández',
    role: 'Dueña de Restaurante',
    content: 'AIRMEX instaló el sistema de climatización de mi restaurante. El equipo trabaja perfectamente y mis clientes siempre están cómodos.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Jorge Ramírez',
    role: 'Gerente de Oficina',
    content: 'Contratamos el mantenimiento trimestral para nuestra oficina. Siempre puntuales y el servicio es impecable. Totalmente recomendados.',
    rating: 5,
  },
  {
    id: 4,
    name: 'Ana López',
    role: 'Arquitecta',
    content: 'Como arquitecta, valoro la calidad y el detalle. AIRMEX superó mis expectativas en la instalación del sistema central de mi proyecto residencial.',
    rating: 5,
  },
  {
    id: 5,
    name: 'Roberto Silva',
    role: 'Dueño de Hotel',
    content: 'Instalaron aires acondicionados en las 20 habitaciones de nuestro hotel. Trabajo impecable, buenos precios y garantía real.',
    rating: 5,
  },
  {
    id: 6,
    name: 'Patricia Gómez',
    role: 'Cliente Residencial',
    content: 'Llamé por una emergencia y en menos de 2 horas ya tenían a mi familia fresca de nuevo. Servicio excepcional y precio justo.',
    rating: 5,
  },
];

export const stats = [
  { value: '15+', label: 'Años de Experiencia' },
  { value: '5,000+', label: 'Instalaciones Completadas' },
];

export const whyChooseUs = [
  {
    id: 1,
    title: 'Técnicos Certificados',
    description: 'Nuestro equipo está compuesto por técnicos certificados con años de experiencia en instalación y mantenimiento de sistemas de climatización.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 2,
    title: 'Garantía Real',
    description: 'Ofrecemos garantía por escrito en todas nuestras instalaciones y reparaciones. Tu inversión está protegida con nosotros.',
    icon: 'ri-award-line',
  },
  {
    id: 4,
    title: 'Precios Justos',
    description: 'Cotizaciones transparentes sin costos ocultos. Ofrecemos los mejores precios del mercado con la más alta calidad de servicio.',
    icon: 'ri-price-tag-3-line',
  },
];

export const processSteps = [
  {
    step: '01',
    title: 'Cotización Gratis',
    description: 'Contactanos y recibí una evaluación y cotización sin compromiso, adaptada a tus necesidades específicas.',
  },
  {
    step: '02',
    title: 'Instalación Profesional',
    description: 'Nuestros técnicos certificados realizan la instalación con los más altos estándares de calidad y seguridad.',
  },
  {
    step: '03',
    title: 'Garantía y Soporte',
    description: 'Disfrutá de tu espacio climatizado con la tranquilidad de nuestra garantía y soporte técnico continuo.',
  },
];